// src/utils/firstGoGrade.js

import { CLIMBING_STYLES } from '../constants.js';
import { logisticRegression, prepareRegressionData } from '../logisticAnalysis.js';

export function calculateFirstGoGrade(data, climbingStyle, yearMode) {
  const isAllTime = yearMode === 'all';
  
  // Use shared data preparation
  const regressionData = prepareRegressionData(data, climbingStyle, yearMode);
  if (!regressionData) {
    return {
      currentGrade: null,
      message: 'Not enough data',
      reason: 'No attempts found'
    };
  }

  const { x, y, years } = regressionData;

if (x.length < 5 || !y.includes(1)) {
  return {
    currentGrade: null,
    message: 'Not enough data',
    reason: x.length < 5 ? 'Need at least 5 attempts' : 'Need at least one flash or onsight'
  };
}

  const regressionResult = logisticRegression(x, y, years, climbingStyle);
  console.log('Regression result:', regressionResult);

  if (!regressionResult) {
    return {
      currentGrade: null,
      message: 'Not enough data',
      reason: 'Regression failed to converge'
    };
  }

  const { m, b } = regressionResult;
  const gradeValue = isAllTime ? b['all'] : b[Object.keys(b)[0]];
  
  return {
    currentGrade: parseFloat(gradeValue?.toFixed(1)),
    gradeByYear: Object.fromEntries(
      Object.entries(b).map(([year, grade]) => [
        year,
        parseFloat(grade.toFixed(1))
      ])
    ),
    slope: m,
    dataPoints: x.length
  };
}